import React from "react";
import styles from "./OccasionsCarousel.module.css";
import { useSwipeable } from "react-swipeable";
import OccasionCarouselItem from "./OccasionCarouselItem";

function OccasionsCarousel({ occasions }) {
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);
  // No refs or scroll logic needed for absolute positioning

  const nextItem = () => {
    setSelectedImageIndex(
      selectedImageIndex === occasions.length - 1 ? 0 : selectedImageIndex + 1,
    );
  };

  const previousItem = () => {
    setSelectedImageIndex(
      selectedImageIndex === 0 ? occasions.length - 1 : selectedImageIndex - 1,
    );
  };

  const handlers = useSwipeable({
    onSwipedLeft: nextItem,
    onSwipedRight: previousItem,
  });

  return (
    <div {...handlers} className={styles.SwipeableContainer}>
      <div className={styles.CarouseContent}>
        {occasions.length > 0 &&
          occasions.map((occasion, index) => (
            <OccasionCarouselItem
              key={occasion.Id}
              occasion={occasion}
              isActive={index === selectedImageIndex}
            />
          ))}
      </div>
    </div>
  );
}

export default OccasionsCarousel;
